/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Export_ButtonInputs */



/**
* | output |
* | --- |
* | "Download" |
*
* @param {Admin_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_export_button = /** @type {((inputs?: Admin_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_ButtonInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Télécharger")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Baixar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica")
	return /** @type {LocalizedString} */ ("Download")
});